const my_profile = {
  viewMyClubSeacretProfile: "عرض ملفي الشخصي في ClubSeacret", // translated
  viewMoreDetails: "عرض المزيد من التفاصيل", // translated
  verifiedEmail: "بريد إلكتروني تم التحقق منه", // translated
  unverifiedEmail: "البريد الإلكتروني لم يتم التحقق منها", // translated
  balance: "توازن", // translated
  pointsIn: "النقاط في", // translated
  pointsOut: "يشير الى", // translated
  topUp: "فوق حتى", // translated
  pointsHistoryTable: "جدول تاريخ النقاط", // translated
  createdFrom: "تم الإنشاء من", // translated
  createdTo: "تم الإنشاء إلى", // translated
  selectStatus: "اختر الحالة...", // translated
  searchByTitle: "البحث حسب العنوان...", // translated
  pushNotifications: "إشعارات الدفع",
  pushNotificationsDescription: "تلقي إشعارات المتصفح للتحديثات والأحداث المهمة",
  pushNotificationsNotSupported: "إشعارات الدفع غير مدعومة في هذا المتصفح",
  pushNotificationsDeniedMessage: "تم رفض إذن الإشعار. يرجى تمكين الإشعارات في إعدادات المتصفح لتلقي إشعارات الدفع.",
  pushNotificationsEnabled: "تم تمكين إشعارات الدفع بنجاح",
  pushNotificationsDisabled: "تم تعطيل إشعارات الدفع بنجاح",
  userInformationMissing: "معلومات المستخدم مفقودة",
  failedToUpdatePushNotifications: "فشل تحديث إعدادات إشعارات الدفع",
  notificationPermissionDenied: "تم رفض إذن الإشعار. يرجى تمكينه في إعدادات المتصفح.",
  notificationPermissionRequired: "إذن الإشعار مطلوب لتمكين إشعارات الدفع",
  notSupported: "غير مدعوم",
  permissionDenied: "تم رفض الإذن",
  permissionNotRequested: "لم يتم طلب الإذن",
  enabled: "مفعل",
  disabled: "معطل",
};

export default my_profile;
